// ** React Imports
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// ** Custom Components
import Avatar from "@components/avatar";

// ** Utils
import { isUserLoggedIn } from "@utils";

// ** Store & Actions
import { handleLogout } from "@store/authentication";
import { useDispatch } from "react-redux";

// ** Third Party Components
import {
  AlertCircle,
  Database,
  Power,
  Server,
  Settings,
  User,
} from "react-feather";

// ** Reactstrap Imports
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

// ** Default Avatar Image
import defaultAvatar from "@src/assets/images/portrait/small/avatar-s-11.jpg";
import axios from "axios";
import { REST_API_WORKSUITE_V3 } from "../../../../constants";
import {
  handleRequestErrors,
  roleUser,
  tokenCompany,
} from "../../../../views/apps/ecommerce/utils/utils";
import { toast } from "react-toastify";

// post token
export const deleteToken = async (token) => {
  const config = {
    method: "post",
    url: `${REST_API_WORKSUITE_V3}accounts/sign-out`,
    headers: {
      Authorization: token,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    throw new Error(error);
  }
};

const UserDropdown = () => {
  // ** Store Vars
  const dispatch = useDispatch();
  // ** State
  const [userData, setUserData] = useState(null);

  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);
  //** Vars

  const userAvatar = userData
    ? userData?.avatar?.image_url ?? userData?.data?.user?.image_url
    : defaultAvatar;
  const token = `Bearer ${userData?.data?.token}`;

  const emailVerified = userData?.data?.user?.email_verified_at;
  const handleLogOutFnc = async () => {
    // const res = await deleteToken(token);
    // if (res.status === 200) {
    dispatch(handleLogout());
    // }
  };
  // const handleSwitch = () => {
  //   let isLink = 0
  //   localStorage.setItem("isLink", isLink)
  //   dispatch(handleLogout())
  // }

  const handleClearCache = () => {
    const res = axios
      .get(`${REST_API_WORKSUITE_V3}clear-cache`, {
        headers: {
          Authorization: token,
          "X-WorkSuite-Company-Token": tokenCompany(),
        },
      })
      .then((res) => {
        toast.success("Cache Cleared Successfully");
        window.location.reload();
      })
      .catch((err) => {
        handleRequestErrors(err);
      });
  };

  const role = roleUser();
  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        to="/"
        tag="a"
        className="nav-link dropdown-user-link "
        onClick={(e) => e.preventDefault()}
      >
        <Avatar
          // id="avatar-admin"
          style={{ fontSize: "0px" }}
          img={userAvatar}
          imgHeight="40"
          imgWidth="40"
          status="online"
        />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem>
          <User size={14} className="me-75" />
          <span className="align-middle" style={{ fontWeight: "600" }}>
            {(userData && userData["fullName"]) || ""}{" "}
            <span style={{ textTransform: "capitalize" }}>
              ({(userData && role) || ""})
            </span>
          </span>
        </DropdownItem>

        {emailVerified === null && (
          <DropdownItem tag={Link} to="/apps/settings/account-settings">
            <AlertCircle
              size={14}
              className="me-75"
              style={{ color: "#FF0000" }}
            />
            <span className="align-middle" style={{ color: "#FF0000" }}>
              Verify Email
            </span>
          </DropdownItem>
        )}

        <DropdownItem tag={Link} to="/apps/dashboard/company">
          <Server size={14} className="me-75" />
          <span className="align-middle">Switch Company</span>
        </DropdownItem>

        <DropdownItem tag={Link} to="/apps/settings/account-settings">
          <Settings size={14} className="me-75" />
          <span className="align-middle">Settings</span>
        </DropdownItem>

        <DropdownItem tag="span" onClick={handleClearCache}>
          <Database size={14} className="me-75" />
          <span className="align-middle">Clear Cache</span>
        </DropdownItem>

        <DropdownItem
          tag="span"
          // tag={Link}
          // to="/accounts"
          onClick={() => handleLogOutFnc()}
        >
          <Power size={14} className="me-75" />
          <span className="align-middle">Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
